import {getTextFromType} from "./helpers";

export const getUseSelectorFromType = (type) => {
    return getTextFromType({string: type, isRemoveSymbols: false, isRemoveSymbolsAndUppercase: true });

}
